import myloadmore from "../assets/js/myloadmore";

var lactalis = (function ($) {
  var _createCookies = function () {
    var settings = $("#cookie_preferences").cookiePreferences("settings");
    if (settings && settings.functionality) {
      // Evento y variable de Google Tag Manager (Funcionalidad)
      dataLayer.push({
        cookie_functionality: "true",
        event: "consent_functionality",
      });
    }

    if (settings && settings.analysis) {
      // Evento y variable de Google Tag Manager (Rendimiento)
      dataLayer.push({
        cookie_analysis: "true",
        event: "consent_analysis",
      });
    }

    if (settings && settings.advertising) {
      // Evento y variable de Google Tag Manager (Dirigidas)
      dataLayer.push({
        cookie_ads: "true",
        event: "consent_ads",
      });
    }
  };

  var _btnLactalis = function () {
    $("#content .caja-texto a").on("mouseout", function () {
      $(this).css({
        color: "white",
        background: "#173254",
      });
    });

    $("#content .caja-texto a").on("mouseover", function () {
      $(this).css({
        background: "#3c6dc6",
      });
    });
  };

  function _updateCookieSelection() {
    // Change tabs
    $("#CookiePreferenceDialogNavDeclaration").on("click", function () {
      // - Hide Configuration Button
      $("#CookiePreferenceDialogBodyShowConfigurationTab").removeClass("hide");

      // - Show Permit selection Button
      $(
        "#CookiePreferenceDialogBodyLevelButtonLevelOptinAllowallSelection"
      ).addClass("hide");
    });

    $("#CookiePreferenceDialogNavDetails").on("click", function () {
      // - Hide Configuration Button
      $("#CookiePreferenceDialogBodyShowConfigurationTab").addClass("hide");

      // - Show Permit selection Button
      $(
        "#CookiePreferenceDialogBodyLevelButtonLevelOptinAllowallSelection"
      ).removeClass("hide");
    });

    $("#CookiePreferenceDialogNavAbout").on("click", function () {
      // - Hide Configuration Button
      $("#CookiePreferenceDialogBodyShowConfigurationTab").removeClass("hide");

      // - Show Permit selection Button
      $(
        "#CookiePreferenceDialogBodyLevelButtonLevelOptinAllowallSelection"
      ).addClass("hide");
    });
  }

  return {
    createCookies: _createCookies,
    btnLactalis: _btnLactalis,
    updateCookieSelection: _updateCookieSelection,
  };
})(jQuery);

export default lactalis;
